module.exports = __webpack_public_path__ + "lc.0d079e39d22ab0c70800.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/lc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/lc.svg
// module chunks = styles